import React from 'react'

const Footer = (): React.ReactElement => {
  return (
    <div
      className="container-fluid d-flex justify-content-center p-2 mt-2"
      style={{ position: 'absolute', bottom: '0px' }}
    >
      <div>
        <a
          href="https://www.iubenda.com/privacy-policy/81008369"
          style={{ color: 'grey' }}
          title="Privacy Policy"
          target="_blank"
        >
          {i18n.t('label_privacyagreement', 'Datenschutzerklärung')}
        </a>{' '}
        &nbsp; &nbsp;
        <a
          href="https://www.iubenda.com/privacy-policy/81008369/cookie-policy"
          style={{ color: 'grey' }}
          title="Cookie Policy"
          target="_blank"
        >
          {i18n.t('label_cookies', 'Cookierichtlinie')}
        </a>
      </div>
    </div>
  )
}

export default Footer
